"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var AppIntegrations_module_css_1 = __importDefault(require("./AppIntegrations.module.css"));
var AppIntegrationResourceLogs = function (props) {
    var _a, _b;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var LogEntryLine = function (attrs) {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, attrs.entry.timestamp.getDate()
                + "/" + (attrs.entry.timestamp.getMonth() + 1)
                + "-" + attrs.entry.timestamp.getFullYear()
                + " " + ("0" + attrs.entry.timestamp.getHours()).slice(-2)
                + ":" + ("0" + attrs.entry.timestamp.getMinutes()).slice(-2)
                + ":" + ("0" + attrs.entry.timestamp.getSeconds()).slice(-2)),
            ": ",
            react_1.default.createElement("span", null, attrs.entry.line)));
    };
    return (react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["resource-log-tab-content"], style: { minHeight: "265px" }, "data-cy": "resourceLogTabContent" },
        react_1.default.createElement("div", { style: { marginTop: "1rem", width: "100%" } },
            react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
                t("Script output"),
                ":"),
            react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["console-container"], style: { borderRadius: "3px" } }, (_b = (_a = props.currentIntegrationJob) === null || _a === void 0 ? void 0 : _a.logs) === null || _b === void 0 ? void 0 : _b.map(function (entry, key) { return (react_1.default.createElement(LogEntryLine, { key: key, entry: entry })); }))),
        props.resourceErrorImageUrl
            ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { style: { marginLeft: "1rem", marginTop: "1rem" } },
                    react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
                        t("Screenshot of script error"),
                        ":"),
                    react_1.default.createElement("div", { style: { textAlign: "center" } },
                        react_1.default.createElement("a", { href: props.resourceErrorImageUrl, target: "_blank", rel: "noreferrer" },
                            react_1.default.createElement("img", { src: props.resourceErrorImageUrl, style: { backgroundColor: "#eeeeee", width: "300px", maxHeight: "300px" }, onError: function (event) { event.currentTarget.src = "/images/no-image-placeholder.svg"; } }))))))
            : (react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.default = AppIntegrationResourceLogs;
